import Image from "@/components/Image";
import { getGrocery } from "@/services";
import useRequest from "@/utils/useReq";
import { Dropdown } from "antd";
import classNames from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";
import HBIcon from "../../HBIcon";
import { useIsNewHeader } from "../headerContext";
import NotificationCenter from "../NotificationCenter";
import styles from "./index.module.less";

export default function RightNav({ user, unreadNum, dmUnread }) {
  const [status, setActiveStatus] = useState(false);
  const router = useRouter();

  const { data: platformData, loading } = useRequest(async () => {
    const { cardList, toolList } = (await getGrocery("f3xgpedu91c")) || {};

    let mapList = [...(cardList || []), ...(toolList || [])];
    for (let i = 0; i < mapList.length; i++) {
      const item = mapList[i];
      if (item.activeKey && !localStorage.getItem(item.activeKey)) {
        setActiveStatus(true);
      }
    }

    return { cardList, toolList };
  });

  const { unread_dm = 0 } = dmUnread || {};

  const totalUnread = unreadNum + unread_dm;

  const platformClick = useCallback(
    (item) => {
      localStorage.setItem(item.activeKey, true);
      const { cardList = [], toolList = [] } = platformData || {};
      let mapList = [...cardList, ...toolList];
      for (let i = 0; i < mapList.length; i++) {
        const data = mapList[i];
        if (data.activeKey && !localStorage.getItem(data.activeKey)) {
          setActiveStatus(true);
          return;
        }
      }
      setActiveStatus(false);
    },
    [platformData]
  );

  const onPlatformVisibleChange = useCallback(
    (e) => {
      if (e === false) {
        platformData?.cardList?.forEach((item) => {
          if (item.activeKey) {
            localStorage.setItem(item.activeKey, true);
          }
        });
        platformData?.toolList?.forEach((item) => {
          if (item.activeKey) {
            localStorage.setItem(item.activeKey, true);
          }
        });
        setActiveStatus(false);
      }
    },
    [platformData]
  );

  const isNewHeader = useIsNewHeader();

  return (
    <div className={styles.nav} style={{ paddingLeft: 4 }}>
      {isNewHeader ? (
        <>
          <div data-tooltip-position="bottom" data-tooltip="花瓣采集插件">
            <Link href="/about/goodies">
              <a
                className={classNames("header-item", styles.pluginIcon)}
                title="花瓣采集插件"
                data-gd-click="button_click"
                data-button-name="花瓣采集插件"
              >
                <HBIcon type="icon1" />
              </a>
            </Link>
          </div>
          {router.pathname !== "/apps" && (
            <div data-tooltip-position="bottom" data-tooltip="花瓣APP">
              <Link href="/apps?hmsr=hbnavi">
                <a
                  className={classNames("header-item", styles.appIcon)}
                  title="花瓣APP"
                  data-gd-click="button_click"
                  data-button-name="花瓣APP"
                >
                  <HBIcon type="phone_fill" />
                </a>
              </Link>
            </div>
          )}
        </>
      ) : (
        <Dropdown
          className={styles.avatar}
          onVisibleChange={onPlatformVisibleChange}
          destroyPopupOnHide
          mouseEnterDelay={0.3}
          mouseLeaveDelay={0.3}
          overlay={
            !loading ? (
              <OtherPlatform
                platformData={platformData}
                onClick={platformClick}
              />
            ) : (
              ""
            )
          }
          placement="bottomRight"
          getPopupContainer={(triggerNode) => triggerNode}
        >
          <span
            className={classNames("header-item", {
              [styles.unread]: status,
            })}
          >
            <HBIcon type="ic_widgets" />
          </span>
        </Dropdown>
      )}
      {user && <NotificationCenter />}
    </div>
  );
}

function OtherPlatform({ platformData, onClick }) {
  return (
    <div
      className={styles.platform}
      data-content-source="九宫格"
      data-resource-title="九宫格"
      data-resource-type="下拉弹窗"
      data-gd-expose="resource_loc_expose"
    >
      <div className={styles.cardList}>
        {platformData.cardList?.map?.((item, index) => (
          <Card key={index} item={item} onClick={onClick} />
        ))}
      </div>
      <div className={styles.more}>
        {platformData.toolList?.map((el, index) =>
          el.type === "divider" ? (
            <div className={styles.divider} key={index}></div>
          ) : (
            <Link href={el.href} key={index}>
              <a
                target={el.type === "inner" ? "_self" : "_blank"}
                data-gd-click="button_click"
                data-button-name={el.title}
                onClick={() => onClick && onClick(el)}
                className={classNames({
                  [styles.news]:
                    el.activeKey && !localStorage.getItem(el.activeKey),
                })}
              >
                <Image
                  src={el.icon[0].url}
                  alt={el.title}
                  width={40}
                  height={40}
                />
                <div>
                  <h5>{el.title}</h5>
                  <span>{el.desc}</span>
                </div>

                <HBIcon
                  type={"launch"}
                  style={{
                    transform:
                      el.type === "inner" ? "rotate(45deg)" : "rotate(0deg)",
                  }}
                />
              </a>
            </Link>
          )
        )}
      </div>
      <div className={styles.bottom}>
        <Link href="/about">
          <a
            target="_blank"
            data-gd-click="button_click"
            data-button-name="关于花瓣"
          >
            <span>关于花瓣</span>
          </a>
        </Link>
        <div className={styles.line}>|</div>
        <Link href="https://support.qq.com/products/30852/change-log">
          <a
            target="_blank"
            data-gd-click="button_click"
            data-button-name="更新日志"
          >
            <span>更新日志</span>
          </a>
        </Link>
        <div className={styles.line}>|</div>
        <Link href="/about/contact">
          <a
            target="_blank"
            data-gd-click="button_click"
            data-button-name="联系我们"
          >
            <span>联系我们</span>
          </a>
        </Link>
        <div className={styles.line}>|</div>
        <Link href="https://support.qq.com/products/30852/faqs-more/?id=108926">
          <a
            target="_blank"
            data-gd-click="button_click"
            data-button-name="侵权投诉"
          >
            <span>侵权投诉</span>
          </a>
        </Link>
      </div>
    </div>
  );
}

function Card({ item, onClick } = {}) {
  return (
    <Link href={item.href}>
      <a
        className={styles.card}
        onClick={() => onClick(item)}
        data-gd-click="button_click"
        data-button-name={item.title}
      >
        <div
          className={styles.bg}
          style={{
            backgroundImage: `url(${item.background[0].url})`,
          }}
        ></div>
        <div className={styles.title}>
          {item.title}
          {item.activeKey && !localStorage.getItem(item.activeKey) && (
            <Image
              className={styles.newsImg}
              src={"https://st0.dancf.com/static/02/202205050532-04fd.svg"}
              width="26"
              alt="new"
            />
          )}
        </div>
        <div className={styles.desc}>{item.desc}</div>
      </a>
    </Link>
  );
}
